import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Trigger = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Trigger" {...props}>
    <path d="M13.207 0.391113C13.4904 0.0227733 13.991 -0.101943 14.4141 0.090332C14.8369 0.282732 15.0716 0.741198 14.9805 1.19678L13.2197 10.0005H20C20.388 10.0005 20.7407 10.2253 20.9053 10.5767C21.0697 10.928 21.0169 11.3431 20.7686 11.6411L10.7686 23.6411C10.4731 23.9954 9.97266 24.1014 9.55859 23.8979C9.14477 23.6944 8.92356 23.2339 9.02344 22.7837L10.7529 15.0005H4C3.6191 15.0005 3.27084 14.7836 3.10254 14.4419C2.93457 14.1004 2.97519 13.6929 3.20703 13.3911L13.207 0.391113ZM6.03125 13.0005H12C12.3033 13.0005 12.5905 13.138 12.7803 13.3745C12.97 13.611 13.0423 13.9213 12.9766 14.2173L11.8701 19.1919L17.8643 12.0005H12C11.7005 12.0005 11.4165 11.8659 11.2266 11.6343C11.0368 11.4027 10.9609 11.0979 11.0195 10.8042L12.1777 5.0083L6.03125 13.0005Z" fill="#000" />
  </StyledIcon>
));

Trigger.displayName = 'Trigger';

export { Trigger };
